import { Link } from 'react-router-dom';
import SearchBox from '@/components/base/SearchBox';
import { categories, sites, topics } from '@/mocks/navData';

const hotKeywords = ['淘宝', '哔哩哔哩', '微博', '知乎', '高德地图'];

const stats = [
  { value: `${sites.length}+`, label: '收录优质网站' },
  { value: `${categories.length}`, label: '核心导航分类' },
  { value: `${topics.length}`, label: '精选主题专题' },
];

export default function HeroBanner() {
  return (
    <section className="relative w-full overflow-hidden rounded-xl">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20blue%20gradient%20technology%20network%20background%20with%20glowing%20connection%20lines%20and%20geometric%20nodes%2C%20clean%20minimal%20modern%20digital%20portal%20aesthetic%2C%20deep%20blue%20tones%20with%20soft%20light%2C%20wide%20banner&width=1600&height=600&seq=nav-hero-portal-01&orientation=landscape"
        alt="蓝导航综合导航平台科技感抽象背景"
        title="蓝导航 便捷的综合导航平台"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/85 via-foreground-950/65 to-primary-950/75"></div>

      <div className="relative z-10 w-full px-6 py-12 md:px-12 md:py-16">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-50 ring-1 ring-background-50/30 dark:text-foreground-950">
          <i className="ri-compass-3-line"></i>
          综合导航平台 · 汇聚优质网站入口
        </span>

        <h1 className="mt-5 max-w-3xl font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl dark:text-foreground-950">
          蓝导航，让每一次上网都更快一步
        </h1>

        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base dark:text-foreground-200">
          一站式聚合新闻、视频、购物、社交等热门领域优质网站，分类清晰、一键直达，帮你快速找到想访问的网站，提升日常上网效率。
        </p>

        <div className="mt-7 w-full max-w-2xl">
          <SearchBox size="lg" />
        </div>

        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-xs text-background-100/80 dark:text-foreground-300">
            热门搜索：
          </span>
          {hotKeywords.map((keyword) => (
            <Link
              key={keyword}
              to={`/search?q=${encodeURIComponent(keyword)}`}
              className="cursor-pointer rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-50 ring-1 ring-background-50/25 transition-colors hover:bg-background-50/20 dark:text-foreground-950"
            >
              {keyword}
            </Link>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-x-10 gap-y-4">
          {stats.map((item) => (
            <div key={item.label}>
              <p className="font-heading text-2xl font-extrabold text-background-50 md:text-3xl dark:text-foreground-950">
                {item.value}
              </p>
              <p className="mt-1 text-xs text-background-100/80 dark:text-foreground-300">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}